import { lazy, Suspense } from "react";
import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import KasinaPage from "@/pages/kasina";
import BonusyPage from "@/pages/bonusy";
import AutomatyPage from "@/pages/automaty";

const PokerPage = lazy(() => import("@/pages/poker"));
const OnlySpinsPage = lazy(() => import("@/pages/onlyspins"));
const AllyspinPage = lazy(() => import("@/pages/allyspin"));
const LegianoPage = lazy(() => import("@/pages/legiano"));
const BassbetPage = lazy(() => import("@/pages/bassbet"));
const FastSlotsPage = lazy(() => import("@/pages/fastslots"));
const SpinangaPage = lazy(() => import("@/pages/spinanga"));
const RabonaPage = lazy(() => import("@/pages/rabona"));
const CasiniaPage = lazy(() => import("@/pages/casinia"));
const StoneVegasPage = lazy(() => import("@/pages/stonevegas"));
const GoldenPandaPage = lazy(() => import("@/pages/goldenpanda"));
const InstantCasinoPage = lazy(() => import("@/pages/instantcasino"));
const BoaBoaPage = lazy(() => import("@/pages/boaboa"));
const AlfCasinoPage = lazy(() => import("@/pages/alfcasino"));
const CadoolaPage = lazy(() => import("@/pages/cadoola"));
const BankonbetPage = lazy(() => import("@/pages/bankonbet"));
const WazambaPage = lazy(() => import("@/pages/wazamba"));
const SpinItPage = lazy(() => import("@/pages/spinit"));
const SgCasinoPage = lazy(() => import("@/pages/sgcasino"));
const LibrabetPage = lazy(() => import("@/pages/librabet"));
const NominiPage = lazy(() => import("@/pages/nomini"));
const PokerKombinacePage = lazy(() => import("@/pages/poker-kombinace"));
const PokerStrategiePage = lazy(() => import("@/pages/poker-strategie"));
const PokerJakHratPage = lazy(() => import("@/pages/poker-jak-hrat"));
const ONasPage = lazy(() => import("@/pages/o-nas"));
const ZasadyCookiesPage = lazy(() => import("@/pages/zasady-cookies"));
const KontaktPage = lazy(() => import("@/pages/kontakt"));
const ZasadyOchranyPage = lazy(() => import("@/pages/zasady-ochrany"));
const NasiAutoriPage = lazy(() => import("@/pages/nasi-autori"));
const RedakcniMetodologiePage = lazy(() => import("@/pages/redakcni-metodologie"));
const ZahranicniPage = lazy(() => import("@/pages/zahranicni"));
const MobilniPage = lazy(() => import("@/pages/mobilni"));
const AutomatyJakVyhratPage = lazy(() => import("@/pages/automaty-jak-vyhrat"));
const PorovnatPage = lazy(() => import("@/pages/porovnat"));
const AutomatySlotyVyplacejiNejvicePage = lazy(() => import("@/pages/automaty-sloty-vyplaceji-nejvice"));

function Router() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin w-8 h-8 border-4 border-[#003da5] border-t-transparent rounded-full" /></div>}>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/kasina" component={KasinaPage} />
        <Route path="/automaty" component={AutomatyPage} />
        <Route path="/automaty/jak-vyhrat" component={AutomatyJakVyhratPage} />
        <Route path="/automaty/sloty-ktere-vyplaceji-nejvice" component={AutomatySlotyVyplacejiNejvicePage} />
        <Route path="/bonusy" component={BonusyPage} />
        <Route path="/poker" component={PokerPage} />
        <Route path="/poker/kombinace" component={PokerKombinacePage} />
        <Route path="/poker/strategie" component={PokerStrategiePage} />
        <Route path="/poker/jak-hrat" component={PokerJakHratPage} />
        <Route path="/kasina/onlyspins" component={OnlySpinsPage} />
        <Route path="/kasina/allyspin" component={AllyspinPage} />
        <Route path="/kasina/legiano" component={LegianoPage} />
        <Route path="/kasina/bassbet" component={BassbetPage} />
        <Route path="/kasina/fastslots" component={FastSlotsPage} />
        <Route path="/kasina/spinanga" component={SpinangaPage} />
        <Route path="/kasina/rabona" component={RabonaPage} />
        <Route path="/kasina/casinia" component={CasiniaPage} />
        <Route path="/kasina/stone-vegas" component={StoneVegasPage} />
        <Route path="/kasina/golden-panda" component={GoldenPandaPage} />
        <Route path="/kasina/instant-casino" component={InstantCasinoPage} />
        <Route path="/kasina/boaboa" component={BoaBoaPage} />
        <Route path="/kasina/alf-casino" component={AlfCasinoPage} />
        <Route path="/kasina/cadoola" component={CadoolaPage} />
        <Route path="/kasina/bankonbet" component={BankonbetPage} />
        <Route path="/kasina/wazamba" component={WazambaPage} />
        <Route path="/kasina/spinit" component={SpinItPage} />
        <Route path="/kasina/sg-casino" component={SgCasinoPage} />
        <Route path="/kasina/librabet" component={LibrabetPage} />
        <Route path="/kasina/nomini" component={NominiPage} />
        <Route path="/kasina/zahranicni" component={ZahranicniPage} />
        <Route path="/kasina/mobilni" component={MobilniPage} />
        <Route path="/porovnat" component={PorovnatPage} />
        <Route path="/o-nas" component={ONasPage} />
        <Route path="/zasady-cookies" component={ZasadyCookiesPage} />
        <Route path="/kontakt" component={KontaktPage} />
        <Route path="/zasady-ochrany-osobnich-udaju" component={ZasadyOchranyPage} />
        <Route path="/nasi-autori" component={NasiAutoriPage} />
        <Route path="/redakcni-metodologie" component={RedakcniMetodologiePage} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
